
<div class="d-flex align-center" style="min-height: 20px">
  <!-- icon -->
  <DataIcon v-if="showIcon"
    :data="data"
    :iconWidth="iconWidth"
    :iconHeight="iconHeight"
    :showFavorite="true"
    :favorite="data.favorite"
  />
  <!-- 이름 (일반 모드) -->
  <div v-if="!isModifyingName" class="d-flex align-center" :style="data.is_locked ? {maxWidth: 'calc(100% - 20px)'} : {maxWidth: '100%'}">
    <v-menu :open-on-hover="hoveredItemIsEllipsis" :disabled="!hoveredItemIsEllipsis" :close-on-content-click="false" :max-width="hoveredItemWidth" open-delay="100" bottom offset-y nudge-top="1px">
      <template v-slot:activator="{ on }">
        <div v-on="on" :class="`data-name-in-data-list-${data.id}`" @mouseover="hoverItem(`.data-name-in-data-list-${data.id}`)"
          style="max-width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; color: #0D0E17"
          :style="showIcon ? {fontSize: nameFontSize, fontWeight: nameFontWeight, paddingLeft: '12px'} : {fontSize: nameFontSize, fontWeight: nameFontWeight}"
        >
          {{ data.name }}
        </div>
      </template>
      <v-card outlined class="px-3 py-2" style="width: 100%">
        <div style="font-size: 12px; word-break: keep-all">
          {{ data.name }}
        </div>
      </v-card>
    </v-menu>
  </div>
  <!-- 이름 (수정 모드) -->
  <div v-else class="d-flex align-center" style="max-width: 100%" v-click-outside="cancelModifyName">
    <!-- 수정창 -->
    <v-text-field @click.stop="clickStop()"
      v-model="data.name" @keyup.enter="modifyName(data)" @keyup.esc="cancelModifyName()" :style="{fontSize: nameFontSize}"
      class="modify-text-input mt-0 pt-0" :class="showIcon ? 'ml-3' : ''" style="width: 100%" hide-details autofocus color="#0D0E17"
    ></v-text-field>
    <!-- 확정 버튼 -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div v-on="on" @click.stop="modifyName(data)"
          class="d-flex align-center justify-center ml-1"
          :class="!data.name.trim() ? 'disabled-icon-btn' : 'default-icon-btn'"
          style="min-width: 18px; max-width: 18px; height: 18px"
        >
          <v-icon style="font-size: 15px">mdi-check</v-icon>
        </div>
      </template>
      <span>확인</span>
    </v-tooltip>
    <!-- 취소 버튼 -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div v-on="on" @click.stop="cancelModifyName()"
          class="default-icon-btn d-flex align-center justify-center ml-1"
          style="min-width: 18px; max-width: 18px; height: 18px"
        >
          <v-icon style="font-size: 15px">mdi-close</v-icon>
        </div>
      </template>
      <span>취소</span>
    </v-tooltip>
  </div>
  <!-- 수정 잠금 표시 -->
  <v-icon v-if="data.is_locked" style="font-size: 16px; color: #ABAEC4; margin-left: 4px">
    mdi-lock
  </v-icon>
</div>
